import { render, staticRenderFns } from "./CustomFieldModalUpdateView.vue?vue&type=template&id=981db1a2&scoped=true"
import script from "./CustomFieldModalUpdateView.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalUpdateView.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalUpdateView.vue?vue&type=style&index=0&id=981db1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981db1a2",
  null
  
)

export default component.exports